var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"container-basic"},[_c('el-container',{staticClass:"all-basic"},[_c('el-header',[_c('LayoutHeader2')],1),_c('el-main',{staticClass:"main"},[_c('router-view',{staticClass:"router-view"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }